// テーブル管理
import commonGridClass from "./commonGridClass";

// 固定列データの定義
var INIT_FIXED_COLUMN_DATA = [
  { columnType: 'send', field: 'send', label: '送信', size: '42px' },
  { columnType: 'draft', field: 'draft', label: 'メール原稿', size: '200px' },
  { columnType: 'card', field: 'card', label: '受講票', select: true, size: '60px' },
  { columnType: 'status', field: 'status', label: 'ステータス', select: true, size: '100px' },
  //{ columnType: 'benefits', field: 'benefits', label: '特典', select: true, size: '60px' },
  //{ columnType: 'benefitsSend', field: 'benefitsSend', label: '特典送付', select: true, size: '60px' },
  { columnType: 'no', field: 'no', label: '番号', size: '90px' },
  { columnType: 'name', field: 'name', label: '氏名', size: '100px' }
];

const GRID_ID = 'grid_dashboard_email';

export default class dashboardEmailGridClass extends commonGridClass {
  // コンストラクタ
  constructor() {
    super();
    this._getSuper();
    this._classValiableDefine();

    this._init();
  }

  // 親classから変数を取得してくる
  _getSuper() {
  }

  // class変数定義
  _classValiableDefine() {
    // 列データ
    this._columnData = [];
    // 選択条件
    this._selectCondition = [];
    // メール原稿の選択肢
    this._optionDraft = [];

    // 一括セット機能UI
    this.$setDraftAllButton = $('.js-w2-checkAll');
    this.$setDraftClearButton = $('.js-w2-checkNone');
    this.$setDraftCheckOnlyButton = $('.js-w2-slct');
    this.$setDraftCardOnlyButton = $('.js-w2-card');

    this.$draftSelect = $('.js-w2-slct-ipt');
  }

  // 初期化用関数
  _init() {
    const cls = this;

    cls._initSetDraft();
  }

  // 「受講票」カラムのラベルhtml生成
  _genCardHtml(txt) {
    switch (txt) {
        case 'OK':
            return '<span class="c-grid_txt" style="color: Green;">' + txt + '</span>';
        case 'NG':
            return '<span class="c-grid_txt" style="color: red;">' + txt + '</span>';
        case '保留':
            return '<span class="c-grid_txt">' + txt + '</span>';
        default:
            return '<span>' + txt + '</span>';
    }
  }

  // 「ステータス」カラムのラベルhtml生成
  _genStatusHtml(txt) {
    switch (txt) {
        case 'OK':
            return '<span class="c-grid_txt" style="color: Green;">' + txt + '</span>';
        case '落NG':
            return '<span class="c-grid_txt" style="color: red;">' + txt + '</span>';
        case '競合NG':
            return '<span class="c-grid_txt" style="color: red;">' + txt + '</span>';
        case '待機':
            return '<span class="c-grid_txt" style="color: Blue;">' + txt + '</span>';
        case 'その他':
            return '<span class="c-grid_txt">' + txt + '</span>';
        default:
            return '<span>' + txt + '</span>';
    }
  }

  /**
   * 一括セット機能の初期化
   */
  _initSetDraft() {
    const cls = this;

    cls.$setDraftAllButton.on('click', function() {
      const draft = cls.$draftSelect.val();

      cls._selectCondition = [];

      w2ui[GRID_ID].records = _.map(w2ui[GRID_ID].records, rcd => {
        rcd.w2ui.class = {};
        rcd.w2ui.sel = 0;
        rcd.send = true;
        rcd.draft = draft;

        // 行単位でリフレッシュ
        w2ui[GRID_ID].refreshRow(rcd['recid']);
        
        return rcd;
      });
      // w2ui[GRID_ID].refresh();
    });

    cls.$setDraftClearButton.on('click', function() {
      cls._clearSelectCondition();
    });

    cls.$setDraftCheckOnlyButton.on('click', function() {
      const draft = cls.$draftSelect.val();

      w2ui[GRID_ID].records = _.map(w2ui[GRID_ID].records, rcd => {
        if (rcd.send) {
          rcd.draft = draft;
        }

        // 行単位でリフレッシュ
        w2ui[GRID_ID].refreshRow(rcd['recid']);

        return rcd;
      });
      // w2ui[GRID_ID].refresh();
    });

    cls.$setDraftCardOnlyButton.on('click', function() {
      const draft = cls.$draftSelect.val();

      cls._clearSelectCondition();
      cls._toggleSelectCondition('card', 'OK');

      w2ui[GRID_ID].records = _.map(w2ui[GRID_ID].records, rcd => {
        if (rcd.send) {
          rcd.draft = draft;
        }

        // 行単位でリフレッシュ
        w2ui[GRID_ID].refreshRow(rcd['recid']);

        return rcd;
      });
      // w2ui[GRID_ID].refresh();
    });
  }

  /**
   * 各列の描画
   */
  _renderColumn(column) {
    const cls = this;

    switch (column.columnType) {
      case 'send': {
        return {
          field: column.field,
          caption: column.label,
          size: column.size,
          min: column.min,
          frozen: true,
          render: function (rcd, idx, col_idx) {
            return cls._genCellCheckBox(rcd.send);
          }
        }
      };
      case 'draft': {
        return {
          field: column.field,
          caption: column.label,
          size: column.size,
          min: column.min,
          frozen: true,
          render: function (rcd, idx, col_idx) {
            return cls._genCellFullSelectBox(cls._optionDraft, rcd.draft, rcd.recid, column.field);
          }
        }
      }
      case 'card': {
        return {
          field: column.field,
          caption: column.label,
          size: column.size || '100px',
          min: column.min,
          attr: column.select ? 'is-selectable' : '',
          frozen: true,
          render: function render(rcd) {
            return cls._genCardHtml(rcd.card);
          }
        };
      }
      case 'status': {
        return {
          field: column.field,
          caption: column.label,
          size: column.size || '100px',
          min: column.min,
          attr: column.select ? 'is-selectable' : '',
          frozen: true,
          render: function render(rcd) {
              return cls._genStatusHtml(rcd.status);
          }
        };
      }
      case 'no':
      case 'name':
      case 'benefits':
      case 'benefitsSend': {
        return {
          field: column.field,
          caption: column.label,
          size: column.size || '100px',
          min: column.min,
          attr: (column.select) ? 'is-selectable': '',
          frozen: true
        };
      }
      case 'info': {
        return {
          field: column.field,
          caption: column.label,
          size: column.size || '100px',
          min: column.min,
          attr: (column.select) ? 'is-selectable' : '',
        };
      }
      case 'delivery': {
        return {
          field: column.field,
          caption: column.label,
          size: column.size || '180px',
          min: column.min,
          attr: (column.select) ? 'is-selectable' : '',
          render: function (rcd, idx, col_idx) {
            let title = '';
            let className = '';
            let _val = '';

            const deliverys = rcd.delivery.split(',');
            // タイトルタイプ毎にループで連番をふる
            for (let i = 0; i < deliverys.length; i++) {
                const types = deliverys[i];
                switch (types) {
                    case '1':
                        title = '受';
                        className = 'is-atnd';
                        break;
                    case '2':
                        title = 'リ';
                        className = 'is-remind';
                        break;
                    case '3':
                        title = '断';
                        className = 'is-cancel';
                        break;
                    case '4':
                        title = '落';
                        className = 'is-unseat';
                        break;
                    case '5':
                        title = '出';
                        className = 'is-conf';
                    default:
                        break;
                }

                _val = _val + '<span class="c-grid_type ' + className + '">' + title + '</span>';
            }

            return _val;

            // switch (rcd.delivery) {
            //   case '受':
            //     title = '受講票';
            //     className = 'is-atnd';
            //     break;
            //   case 'リ':
            //     title = 'リマインド';
            //     className = 'is-remind';
            //     break;
            //   case '断':
            //     title = 'お断り';
            //     className = 'is-cancel';
            //     break;
            //   case '落':
            //     title = '落選';
            //     className = 'is-unseat';
            //     break;
            //   case '出':
            //     title = '出欠確認';
            //     className = 'is-conf';
            //   default:
            //     break;
            // }
            // return `<span class="c-grid_type ${className}">${title}</span>`;
          }
        };
      }
      default: {
        return null;
      }
    }
  }

  /**
   * 各行の描画
   * @param {*} rcd
   */
  _renderRecord(rcd) {
    const cls = this;

    rcd.w2ui = { class : {}, sel: 0 };

    return rcd;
  }

  /**
   * 選択条件をクリア
   */
  _clearSelectCondition() {
    const cls = this;

    cls._selectCondition = [];

    w2ui[GRID_ID].records = _.map(w2ui[GRID_ID].records, rcd => {
      rcd.w2ui.class = {};
      rcd.w2ui.sel = 0;
      rcd.send = false;

      // 行単位でリフレッシュ
      w2ui[GRID_ID].refreshRow(rcd['recid']);

      return rcd;
    });
    // w2ui[GRID_ID].refresh();
  }

  /**
   * 選択条件の切り替え
   * @param {*} field
   * @param {*} value
   */
  _toggleSelectCondition(field, value) {
    const cls = this;

    const conditionIndex = _.findIndex(cls._selectCondition, item => item.field === field && item.value === value);
    const hasCondition = conditionIndex > -1;
    if (hasCondition) {
      cls._selectCondition.splice(conditionIndex, 1);
    } else {
      cls._selectCondition.push({ field, value });
    }

    const conditionColumnCount = _(cls._selectCondition).groupBy('field').size();

    w2ui[GRID_ID].records = _.map(w2ui[GRID_ID].records, rcd => {
      if (rcd[field] === value) {
        if (hasCondition) {
          rcd.w2ui.class[field] = null;
          rcd.w2ui.sel--;
        } else {
          rcd.w2ui.class[field] = 'is-selected';
          rcd.w2ui.sel++;
        }
      }
      rcd.send = (conditionColumnCount > 0 && rcd.w2ui.sel === conditionColumnCount);

      // 行単位でリフレッシュ
      w2ui[GRID_ID].refreshRow(rcd['recid']);

      return rcd;
    });
    // w2ui[GRID_ID].refresh();
  }

  /**
   * Eメールテーブルの初期化
   * @param {*} rcdObj
   */
  initDashboardEmailGrid(rcdRow, rcdColumn, optionDraft) {

    // 既に定義済みであれば削除する
    if (w2ui[GRID_ID] !== undefined) {
      w2ui[GRID_ID].destroy();
    }

    var cls = this;
    var $tgt = $('.js-grid_dashboard_email');

    // 列の番号からフィールド名を取得
    const getFieldFromColumnIndex = (columnIndex) => w2ui[GRID_ID].columns[columnIndex] && w2ui[GRID_ID].columns[columnIndex].field;

    // 列データの初期化
    cls._columnData = _.concat(INIT_FIXED_COLUMN_DATA, rcdColumn);

    // メール機能選択肢の初期化
    cls._optionDraft = optionDraft;

    // 20行未満は高さ変動
    var fixedheight = false;
    if (rcdRow.length > 20) {
        fixedheight = true;
    }

    $tgt.w2grid({
      disableCVS: false, // スクロール時の動的なDOM生成をしないか(レコードが少ないときはtrueの方が早い)
      name: GRID_ID,
      fixedBody: fixedheight,
      recordHeight: 26,
      columns: this._columnData.map(item => this._renderColumn(item)),
      records: rcdRow.map(item => this._renderRecord(item)),
      // セルタップ時のイベント
      onClick: function(event) {
        const { recid, column } = event;
        const field = getFieldFromColumnIndex(column);
        const value = w2ui[GRID_ID].getCellValue(recid - 1, column);

        switch (field) {
          case 'send': {
            w2ui[GRID_ID].records[recid - 1].send = !value;
            w2ui[GRID_ID].refreshCell(recid, 'send');
            break;
          }
          default: {
            if (cls._columnData[column].select) {
              cls._toggleSelectCondition(field, value);
            }
            break;
          }
        }
      }
    });

    $tgt.on('change', 'select', function(event) {
      const $target = $(event.target);
      const value = $target.val();
      const recid = $target.data('recid');
      const field = $target.data('field');
      if (recid !== null && field !== null) {
        w2ui[GRID_ID].records[recid - 1][field] = value;
      }
    });
  }

}